import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { SkeletonComponent } from '../../../shared/components/skeleton/skeleton.component';

@Component({
  selector: 'app-no-item-selected',
  imports: [MatIconModule, TranslateModule, MatCardModule, SkeletonComponent],
  templateUrl: './no-item-selected.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './no-item-selected.component.scss',
})
export class NoItemSelectedComponent {}
